import releasesData from "@/content/releases.json";
import { useT } from "@/lib/i18n";
import { Reveal } from "./Reveal";
import { SectionHeading } from "./SectionHeading";
import { SECTION_CLS, type Release } from "./Releases";

export const Catalog = () => {
  const t = useT();
  const rows = releasesData.releases as Release[];

  return (
    <section id="catalog" data-testid="catalog-section" className={SECTION_CLS}>
      <SectionHeading
        index={t.catalog.index}
        eyebrow={t.catalog.eyebrow}
        title={t.catalog.title}
        testId="catalog-heading"
      />
      <Reveal>
        <div className="border-t border-if-line" data-testid="catalog-list">
          <div className="hidden grid-cols-12 gap-4 border-b border-if-line py-4 font-sans text-[10px] uppercase tracking-[0.25em] text-if-dim md:grid">
            <span className="col-span-5">{t.catalog.colTitle}</span>
            <span className="col-span-3">{t.catalog.colArtist}</span>
            <span className="col-span-2">{t.catalog.colFormat}</span>
            <span className="col-span-2 text-right">{t.catalog.colLinks}</span>
          </div>
          {rows.length === 0 ? (
            <p
              data-testid="catalog-pending"
              className="border-b border-if-line py-10 text-sm font-light text-if-dim"
            >
              {t.catalog.pending}
            </p>
          ) : (
            rows.map((r) => (
              <div
                key={r.id}
                data-testid={`catalog-row-${r.id}`}
                className="grid grid-cols-2 gap-4 border-b border-if-line py-5 transition-transform duration-500 hover:translate-x-1 md:grid-cols-12"
              >
                <span className="col-span-1 font-serif text-xl font-light text-if-text md:col-span-5">
                  {r.title}
                </span>
                <span className="col-span-1 text-sm text-if-dim md:col-span-3">
                  {r.artist}
                </span>
                <span className="text-sm text-if-dim md:col-span-2">
                  {r.format}
                </span>
                <span className="flex gap-3 font-sans text-[10px] uppercase tracking-[0.2em] text-if-gold md:col-span-2 md:justify-end">
                  {r.links?.youtube ? (
                    <a
                      href={r.links.youtube}
                      target="_blank"
                      rel="noopener noreferrer"
                      data-testid={`catalog-${r.id}-youtube`}
                      className="transition-colors duration-300 hover:text-if-text"
                    >
                      {t.releases.watchYoutube}
                    </a>
                  ) : (
                    <span className="text-if-dim/50">—</span>
                  )}
                </span>
              </div>
            ))
          )}
        </div>
      </Reveal>
    </section>
  );
};
